import Vue from "vue";
import VModal from "vue-js-modal";
import Loading from "vue-loading-overlay";
import ShardsVue from "shards-vue";
import VueCookies from "vue-cookies";
import store from "./store";
import VueAxios from "axios";
import Website from "@/service/Website";
import Developer from "@/service/Developer";
import User from "@/service/User";
import AffiliateNetwork from "@/service/AffiliateNetwork";
import Transactions from "@/service/Transactions";
import VisitorProfiles from "@/service/VisitorProfiles";
import SubUsers from "@/service/SubUsers";
import Auth from "@/service/Auth";
import Facebook from "@/service/Facebook";
import Ga from "@/service/Ga";
import GoogleAnalyticsV4 from "@/components/integrations/google-analytics-v4/Service";
import GoogleAnalyticsOAuth from "@/components/integrations/google-analytics-oauth/Service";
import Ba from "@/service/Ba";
import Billing from "@/service/Billing";
import Analysis from "@/service/Analysis";
import Country from "@/resources/CountryResource";
import Currency from "@/resources/CurrencyResource";
import Performance from "@/service/Performance";
import Summary from "@/service/Summary";
import HandlerErrorMessages from "@/service/HandlerErrorMessages";
import Notification from "@/service/Notification";
import Notifications from "vue-notification";
import Cookies from "js-cookie";
import Datepicker from "vuejs-datepicker";
import Pagination from "vue-pagination-2";
import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";
import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import VueApollo from "vue-apollo";
import vueCountryRegionSelect from "vue-country-region-select";
import { ClientTable } from "vue-tables-2";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Clipboard from "v-clipboard";
import ToggleButton from "vue-js-toggle-button";
import "@/helpers/filters";
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import * as rules from 'vee-validate/dist/rules';

import "bootstrap/dist/css/bootstrap.css";
import "vue-loading-overlay/dist/vue-loading.css";

import App from "./App.vue";
import router from "./router";

import Default from "@/layouts/Default.vue";
import Login from "@/layouts/Login.vue";
import HeaderNavigation from "@/layouts/HeaderNavigation.vue";
import IconSidebar from "@/layouts/IconSidebar.vue";

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import AsyncComputed from "vue-async-computed";

import VueSweetalert2 from "vue-sweetalert2";
import KeuzeNL from "@/service/KeuzeNL";
import KiziNL from "@/service/KiziNL";
import Kickbite from "@/service/Kickbite";
import middleware from "vue-router-middleware-system";

console.log('branch IV-2390');
// Export class instances
export const WebsiteService = new Website();
export const UserService = new User();
export const AuthService = new Auth();
export const AffiliateNetworkService = new AffiliateNetwork();
export const FacebookIntegrationService = new Facebook();
export const GaService = new Ga();
export const GoogleAnalyticsV4Service = new GoogleAnalyticsV4();
export const BaService = new Ba();
export const CountryResource = new Country();
export const DeveloperService = new Developer();
export const BillingService = new Billing();
export const TransactionService = new Transactions();
export const VisitorProfilesService = new VisitorProfiles();
export const CurrencyResource = new Currency();
export const PerformanceService = new Performance();
export const SummaryService = new Summary();
export const ErrorService = new HandlerErrorMessages();
export const NotificationService = new Notification();
export const AnalysisService = new Analysis();
export const SubUsersService = new SubUsers();
export const GoogleAnalyticsOAuthService = new GoogleAnalyticsOAuth();
export const KeuzeNLIntegration = new KeuzeNL();
export const KiziNLIntegration = new KiziNL();
export const KickbiteIntegration = new Kickbite();

// others
function setLoginAsToken() {
    if (AuthService.detectToken()) {
        Cookies.set("token", AuthService.detectToken());
        router.push("/");
        router.go();
    }
}

function deleteTokenAndLogout() {
    $cookies.remove("token");
    $cookies.remove("tokenTime");
    router.push("/");
    Vue.notify({
        group: "alert",
        title: "You’ve logged out!",
        text: "Token has expired. Please log in again!"
    });
    router.go();
}

setLoginAsToken();

const httpLink = createHttpLink({
    uri: process.env.VUE_APP_API_URL + "/auth"
});

const errorLink = onError(({ networkError }) => {
    if (networkError) {
        if ([400, 401].indexOf(networkError.statusCode) !== -1) {
            deleteTokenAndLogout()
        }
    }
});

const middlewareLink = new ApolloLink((operation, forward) => {
    operation.setContext({
        headers: {
            Authorization: `Bearer ${Cookies.get("token")}`
        }
    });
    return forward(operation);
});

const authLink = middlewareLink.concat(httpLink);

const graphLink = createHttpLink({
    uri: process.env.VUE_APP_API_URL
});

const cache = new InMemoryCache();

export const authClient = new ApolloClient({
    link: errorLink.concat(authLink),
    cache,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: "no-cache",
            errorPolicy: "ignore"
        },
        query: {
            fetchPolicy: "no-cache",
            errorPolicy: "all"
        }
    }
});

export const graphClient = new ApolloClient({
    link: graphLink,
    cache,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: "no-cache",
            errorPolicy: "ignore"
        },
        query: {
            fetchPolicy: "no-cache",
            errorPolicy: "all"
        }
    }
});

const apolloProvider = new VueApollo({
    clients: {
        authClient,
        graphClient
    },

    defaultClient: authClient
});

export const axios = VueAxios.create({
    headers: {
        Authorization: "Bearer " + $cookies.get("token")
    }
});

Sentry.init({
    dsn: process.env.VUE_APP_SENTRY,
    integrations: [new VueIntegration({ Vue, attachProps: true })]
});

axios.interceptors.request.use(function (config) {
    let tokenTime = Number(AuthService.getTokenTime())
    if (AuthService.getTokenTime() && tokenTime < Date.now()) {
        deleteTokenAndLogout()
    }
    return config
}, function (error) {
    return Promise.reject(error);
});

if (process.env.NODE_ENV == "development") {
    Vue.config.devtools = true;
}

ShardsVue.install(Vue);

Vue.component("default-layout", Default);
Vue.component("login-layout", Login);
Vue.component("header-navigation-layout", HeaderNavigation);
Vue.component("pagination", Pagination);
Vue.component("icon-sidebar-layout", IconSidebar);
Vue.component("datepicker", Datepicker);
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
extend('not_starts_with', {
    params: ['prefixes'],
    validate(value, { prefixes }) {
        let valid = true
        prefixes.forEach((prefix) => {
            if (value.startsWith(prefix)) {
                valid = false
            }
        });
        return valid;
    },
    message: 'The field cannot start with this value'
});
localize('en', en);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(ClientTable);
Vue.use(vueCountryRegionSelect);
Vue.use(VModal);
Vue.use(Clipboard);
Vue.use(VueApollo);
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Notifications);
Vue.use(Loading);
Vue.use(ToggleButton);
Vue.use(VueSweetalert2);
Vue.use(AsyncComputed);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

router.beforeResolve(middleware( { store } ))

new Vue({
    router,
    store,
    apolloProvider,
    render: h => h(App)
}).$mount("#app");
